import axios from 'axios';
import { domainDefault } from '@libs/@core/constants/env';
import { getAccessTokenCookie } from '@libs/utils/serverHelpers';
var axiosServices = axios.create({
    baseURL: domainDefault || '',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
});
axios.interceptors.request.use(function (response) {
    response.headers['Accept-Language'] = localStorage.getItem('language') || 'en';
    return response;
}, function (error) { return Promise.reject(error); });
// interceptor for http
axiosServices.interceptors.request.use(function (response) {
    response.headers['Accept-Language'] = localStorage.getItem('language') || 'en';
    var accessToken = getAccessTokenCookie();
    if (accessToken) {
        response.headers['Authorization'] = "Bearer ".concat(accessToken);
    }
    return response;
}, function (error) { return Promise.reject(error); });
axiosServices.interceptors.response.use(function (response) {
    response.headers['ngonngu'] = 'en';
    return response;
}, function (error) {
    if (error.response && error.response.config.headers['Authorization'] && error.response.status === 401) {
        return Promise.reject(error);
    }
    return Promise.reject(error);
});
export default axiosServices;
